<script>
  import solicitacaoReembolsoServico from '../servico';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import tiposConta from '~js/tipos-conta';
  import formasPagamento from '~js/formas-pagamento';
  import Barcode from '@xkeshi/vue-barcode';

  export default {
    components: { Cabecalho, Barcode },
    data() {
      return {
        solicitacoes: {},
        carregando: true,
        configuracao: this.$storage.configuracao(),
        mostrarReembolso: null,
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoReembolsoServico
          .relatorio(id)
          .then(solicitacoes => {
            this.carregando = false;
            this.solicitacoes = solicitacoes;
            this.mostrarReembolso = solicitacoes[0].tipoReembolso;
          });
      },
      tipoConta(tipo) {
        return tiposConta.find(tc => {
          return tc.id === tipo;
        }).nome;
      },
      formaPagamento(id) {
        return formasPagamento.find(f => {
          return f.id === id;
        });
      },
      valorTotalDiaria(solicitacao) {
        const quantidade = this.$options.filters.formatarNumero(solicitacao.quantidadeDiaria || 0, true);
        const quantidadeInteiro = parseInt(quantidade);
        const quantidadeDecimal = parseFloat(quantidade - quantidadeInteiro);
        let valorUnitario = this.$options.filters.formatarNumero(solicitacao.valorUnitarioDiaria || 0, true);
        const valorTotalKmRodado = this.$options.filters.formatarNumero(solicitacao.valorTotalKmRodado || 0, true);
        const taxaEmbarque = this.$options.filters.formatarNumero(solicitacao.taxaEmbarque || 0, true);
        const descontoAlimentacao = this.$options.filters.formatarNumero(solicitacao.descontoAlimentacao || 0, true);

        const totalComMeiaDiaria = (quantidadeDecimal > 0 ? (quantidadeDecimal * valorUnitario) : 0);

        if (valorUnitario > 0 && solicitacao.incluiHospedagem && this.configuracao.pagarDiariaMetadeComHospedagem) {
          valorUnitario /= 2;
        }

        const totalSemMeiaDiaria = (quantidadeInteiro * valorUnitario) + taxaEmbarque + valorTotalKmRodado - descontoAlimentacao;

        return (totalSemMeiaDiaria + totalComMeiaDiaria).toFixed(2);
      }
    },
    computed: {
      periodoDeVigencia() {
        let dataInicio = this.solicitacoes[0].projeto.dataInicioVigencia;
        let dataTermino = this.solicitacoes[0].projeto.dataTerminoVigencia;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }

        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }

        return periodo;
      },
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacoes[0].liberacaoCoordenador) || '---';
      },
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Diária ${ this.configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '' } ${ this.configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '' } Estrangeiro - Relatório`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-reembolso-estrangeiro';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <p v-show="carregando" class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </p>

            <div v-if="!carregando">

              <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
                <template v-for="solicitacao in solicitacoes">
                  <div class="btn-group" role="group" v-if="solicitacao.tipoReembolso === 1">
                    <button type="button" :class="['btn btn-primary', {'active': mostrarReembolso === 1}]" @click="mostrarReembolso = 1">
                      <i class="fa fa-building-o"></i> Diária
                    </button>
                  </div>
                  <div class="btn-group" role="group" v-if="solicitacao.tipoReembolso === 0">
                    <button type="button" :class="['btn btn-primary', {'active': mostrarReembolso === 0}]" @click="mostrarReembolso = 0">
                      <i class="fa fa-plane"></i> Passagem
                    </button>
                  </div>
                  <div class="btn-group" role="group" v-if="solicitacao.tipoReembolso === 2">
                    <button type="button" :class="['btn btn-primary', {'active': mostrarReembolso === 2}]" @click="mostrarReembolso = 2">
                      <i class="fa fa-money"></i> Adiantamento
                    </button>
                  </div>
                </template>
              </div>

              <template v-for="solicitacao in solicitacoes">
                <div v-show="solicitacao.tipoReembolso === mostrarReembolso">
                  <cabecalho :titulo="`Solicitação de Diária ${ configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '' } ${ configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '' }`"></cabecalho>

                  <h3 class="m-t-none">Dados da solicitação</h3>
                  <div class="hr-line-dashed margin-top-5 margin-bottom-10"></div>

                  <div class="row">
                    <dl class="col-xs-8">
                      <dt>Projeto</dt>
                      <dd>{{ solicitacao.projeto ? solicitacao.projeto.nomeProjeto : '' }}</dd>
                    </dl>
                    <dl class="col-xs-4">
                      <dt>Tipo de projeto</dt>
                      <dd>{{ solicitacao.projeto.tipoProjeto ? solicitacao.projeto.tipoProjeto.nome : '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-xs-6">
                      <dt>Período de vigência</dt>
                      <dd>{{ periodoDeVigencia }}</dd>
                    </dl>
                    <dl class="col-xs-6">
                      <dt>Nr. processo</dt>
                      <dd>{{ solicitacao.projeto ? solicitacao.projeto.nrProcesso : '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-xs-3">
                      <dt>Número</dt>
                      <dd>{{ solicitacao.idSolicitacaoReembolso || '---' }}</dd>
                    </dl>
                    <dl class="col-xs-3">
                      <dt>Data da solicitação</dt>
                      <dd>{{ solicitacao.dataSolicitacao | formatarNumeroEmDataExtenso }}</dd>
                    </dl>
                    <dl class="col-xs-3">
                      <dt>Solicitante</dt>
                      <dd>{{ solicitacao.solicitante ? solicitacao.solicitante.nomePessoaFisicaJuridica : '---' }}</dd>
                    </dl>
                    <dl class="col-xs-3">
                      <dt>Coordenador do projeto</dt>
                      <dd>{{ solicitacao.projeto.coordenador ? solicitacao.projeto.coordenador.nomePessoaFisicaJuridica : '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row">
                    <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                      <dt>Data de liberação do coordenador</dt>
                      <dd>{{ dataLiberacaoCoordenador }}</dd>
                    </dl>
                    <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                      <dt>Liberado por</dt>
                      <dd>{{ solicitacao.liberadoPor ? solicitacao.liberadoPor.nomePessoaFisicaJuridica : '---' }}</dd>
                    </dl>
                    <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                      <dt>Nº protocolo</dt>
                      <dd>{{ solicitacao.protocolo ? solicitacao.protocolo.numeroProtocolo : '---' }}</dd>
                    </dl>
                    <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                      <dt>Código de barras protocolo</dt>
                      <dd><barcode :value="solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                    </dl>
                  </div>

                  <div class="row" v-if="configuracao.utilizarDetalheRateioSolicitacao">
                    <dl class="col-xs-12">
                      <dt>Detalhe rateio</dt>
                      <dd>{{ solicitacao.detalheRateio ? solicitacao.detalheRateio.nome : '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row" v-if="configuracao.selecaoDeContaWeb">
                    <dl class="col-xs-12">
                      <dt>Conta</dt>
                      <dd>{{ solicitacao.conta ? solicitacao.conta.nome : '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row" v-if="solicitacao.projeto.utilizarMetaEtapaProjeto">
                    <dl class="col-xs-12">
                      <dt>Meta Etapa</dt>
                      <dd>
                        {{ solicitacao.projetoMetaEtapa.meta ? solicitacao.projetoMetaEtapa.meta.nome : '' }}
                        -
                        {{ solicitacao.projetoMetaEtapa.etapa ? solicitacao.projetoMetaEtapa.etapa.nome : '' }}
                      </dd>
                    </dl>
                  </div>

                  <div class="row" v-if="configuracao.exibirRubricaSubrubricaSolicitacaoWeb">
                    <dl class="col-xs-6">
                      <dt>Rubrica</dt>
                      <dd>{{ solicitacao.rubrica ? solicitacao.rubrica.nome : '---' }}</dd>
                    </dl>

                    <dl class="col-xs-6">
                      <dt>Subrubrica</dt>
                      <dd>{{ solicitacao.subrubrica ? solicitacao.subrubrica.nome : '---' }}</dd>
                    </dl>
                  </div>

                  <h3 class="m-t-none">Dados cadastrais</h3>
                  <div class="hr-line-dashed margin-top-5 margin-bottom-10"></div>

                  <div class="row">
                    <dl class="col-xs-8">
                      <dt>Nome</dt>
                      <dd>{{ solicitacao.nomeTerceiro || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-4">
                      <dt>Email do beneficiário</dt>
                      <dd>{{ solicitacao.documentoTerceiro || '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-xs-6">
                      <dt>Data de nascimento</dt>
                      <dd>{{ solicitacao.dataNascimento | formatarNumeroEmData('---') }}</dd>
                    </dl>

                    <dl class="col-xs-6">
                      <dt>Identidade</dt>
                      <dd>{{ solicitacao.identidade || '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-xs-6">
                      <dt>Endereço</dt>
                      <dd>{{ solicitacao.endereco || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>Número</dt>
                      <dd>{{ solicitacao.numero || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>Complemento</dt>
                      <dd>{{ solicitacao.complemento || '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-xs-4">
                      <dt>Bairro</dt>
                      <dd>{{ solicitacao.bairro || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-5">
                      <dt>Cidade</dt>
                      <dd>{{ solicitacao.cidade || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>País</dt>
                      <dd>{{ solicitacao.pais || '---' }}</dd>
                    </dl>
                  </div>

                  <div class="row">
                    <dl class="col-xs-4">
                      <dt>Tel. residencial</dt>
                      <dd>{{ solicitacao.telefoneResidencial || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-4">
                      <dt>Tel. comercial</dt>
                      <dd>{{ solicitacao.telefoneComercial || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-4">
                      <dt>Fax</dt>
                      <dd>{{ solicitacao.fax || '---' }}</dd>
                    </dl>
                  </div>

                  <h3 class="m-t-none">Dados para o pagamento</h3>
                  <div class="hr-line-dashed margin-top-5 margin-bottom-10"></div>

                  <div class="row">
                    <dl class="col-xs-6" v-if="configuracao.exibirDataPgtoSolicitacaoPgto">
                      <dt>Data para pagamento</dt>
                      <dd>{{ solicitacao.dataPagamento | formatarNumeroEmData }}</dd>
                    </dl>

                    <dl :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-xs-6' : 'col-xs-12']">
                      <dt>Forma de pagamento</dt>
                      <dd>{{ solicitacao.formaPagamento !== null ? formaPagamento(solicitacao.formaPagamento).nome : '---' }}</dd>
                    </dl>
                  </div>

                  <h3 class="m-t-none" style="margin-bottom: 9px;">Dados da viagem</h3>
                  <div class="hr-line-dashed margin-top-5 margin-bottom-10"></div>

                  <h4 class="m-t-none">Ida</h4>

                  <div class="row">
                    <dl class="col-xs-3">
                      <dt>Origem</dt>
                      <dd>{{ solicitacao.origemIda || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>Destino</dt>
                      <dd>{{ solicitacao.destinoIda || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Data</dt>
                      <dd>{{ solicitacao.dataIda | formatarNumeroEmData }}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Horário de saída</dt>
                      <dd>{{ solicitacao.horarioIda || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Horário de chegada</dt>
                      <dd>{{ solicitacao.horarioChegadaIda || '---' }}</dd>
                    </dl>
                  </div>

                  <h4 class="m-t-none" v-if="!solicitacao.apenasIda">Volta</h4>

                  <div class="row" v-if="!solicitacao.apenasIda">
                    <dl class="col-xs-3">
                      <dt>Origem</dt>
                      <dd>{{ solicitacao.origemVolta || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>Destino</dt>
                      <dd>{{ solicitacao.destinoVolta || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Data</dt>
                      <dd>{{ solicitacao.dataVolta | formatarNumeroEmData }}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Horário de saída</dt>
                      <dd>{{ solicitacao.horarioVolta || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Horário de chegada</dt>
                      <dd>{{ solicitacao.horarioChegadaVolta || '---' }}</dd>
                    </dl>
                  </div>

                  <div v-if="solicitacao.tipoReembolso === 0">
                    <h3 class="m-t-none">Passagem</h3>
                    <div class="hr-line-dashed margin-top-5 margin-bottom-10"></div>

                    <div class="row">
                      <dl class="col-xs-4">
                        <dt>Despachar Bagagem</dt>
                        <dd>{{ solicitacao.despacharBagagem ? 'Sim' : 'Não' }}</dd>
                      </dl>
                    </div>

                    <h4 class="m-t-none">Ida</h4>

                    <div class="row">
                      <dl class="col-xs-4">
                        <dt>Quantidade</dt>
                        <dd>{{ solicitacao.quantidadePassagemIda || '---' }}</dd>
                      </dl>

                      <dl class="col-xs-4">
                        <dt>Valor estimado</dt>
                        <dd>{{ solicitacao.valorPassagemIda | formatarNumero }}</dd>
                      </dl>

                      <dl class="col-xs-4">
                        <dt>Tipo de passagem</dt>
                        <dd>{{ solicitacao.tipoPassagemIda ? solicitacao.tipoPassagemIda.descricaoTipoPassagem : '---' }}</dd>
                      </dl>
                    </div>

                    <div v-if="!solicitacao.apenasIda">
                      <h4 class="m-t-none">Volta</h4>

                      <div class="row">
                        <dl class="col-xs-4">
                          <dt>Quantidade</dt>
                          <dd>{{ solicitacao.quantidadePassagemVolta || '---' }}</dd>
                        </dl>

                        <dl class="col-xs-4">
                          <dt>Valor estimado</dt>
                          <dd>{{ solicitacao.valorPassagemVolta | formatarNumero }}</dd>
                        </dl>

                        <dl class="col-xs-4">
                          <dt>Tipo de passagem</dt>
                          <dd>{{ solicitacao.tipoPassagemVolta ? solicitacao.tipoPassagemVolta.descricaoTipoPassagem : '---' }}</dd>
                        </dl>
                      </div>

                      <div class="row">
                        <dl class="col-xs-12">
                          <dt>Motivo</dt>
                          <dd class="white-space-pre">{{ solicitacao.motivoAdiantamento || '---' }}</dd>
                        </dl>
                      </div>

                      <div class="row">
                        <dl class="col-xs-12">
                          <dt>Indicação de companhia/empresa</dt>
                          <dd class="white-space-pre">{{ solicitacao.indicacaoFornecedor || '---' }}</dd>
                        </dl>
                      </div>
                    </div>
                  </div>

                  <div v-if="solicitacao.tipoReembolso === 1">
                    <h3 class="m-t-none">Diária</h3>
                    <div class="hr-line-dashed margin-top-5 margin-bottom-10"></div>

                    <div class="row">
                      <dl class="col-xs-6">
                        <dt>Diária para contrato CLT</dt>
                        <dd>{{ solicitacao.diariaCeletista ? 'Sim' : 'Não' }}</dd>
                      </dl>

                      <dl class="col-xs-6">
                        <dt>A {{ configuracao.abreviaturaFundacao }} fornecerá hospedagem</dt>
                        <dd>{{ solicitacao.incluiHospedagem ? 'Sim' : 'Não' }}</dd>
                      </dl>
                    </div>

                    <div class="row">
                      <dl class="col-xs-2">
                        <dt>Quantidade</dt>
                        <dd>{{ solicitacao.quantidadeDiaria | formatarNumero }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                        <dt>Valor unitário</dt>
                        <dd>{{ solicitacao.valorUnitarioDiaria | formatarNumero }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                        <dt>Taxa de embarque / deslocamento</dt>
                        <dd>{{ solicitacao.taxaEmbarque | formatarNumero }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                        <dt>Desconto alimentação</dt>
                        <dd>{{ solicitacao.descontoAlimentacao | formatarNumero }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                        <dt>Valor total de KM rodado</dt>
                        <dd>{{ solicitacao.valorTotalKmRodado | formatarNumero }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                        <dt>Valor total</dt>
                        <dd>{{ valorTotalDiaria(solicitacao) | formatarNumero }}</dd>
                      </dl>
                    </div>

                    <div class="row">
                      <dl class="col-xs-12">
                        <dt>Motivo</dt>
                        <dd class="white-space-pre">{{ solicitacao.motivoAdiantamento || '---' }}</dd>
                      </dl>
                    </div>
                  </div>

                  <div v-if="solicitacao.tipoReembolso === 2">
                    <h3 class="m-t-none">Adiantamento</h3>
                    <div class="hr-line-dashed margin-top-5 margin-bottom-10"></div>

                    <div class="row">
                      <dl class="col-xs-12">
                        <dt>Motivo</dt>
                        <dd class="white-space-pre">{{ solicitacao.motivoAdiantamento || '---' }}</dd>
                      </dl>
                    </div>

                    <div class="row">
                      <dl class="col-xs-2">
                        <dt>Valor</dt>
                        <dd>{{ solicitacao.valorAdiantamento | formatarNumero }}</dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </template>

              <div class="hr-line-dashed margin-top-5" v-if="this.configuracao.solDiariaEstrangeiroMsgConfirmacao"></div>

              <div class="row" v-if="this.configuracao.solDiariaEstrangeiroMsgConfirmacao">
                <div class="col-md-12">
                  <p><i>{{this.configuracao.solDiariaEstrangeiroMsgConfirmacao}}</i></p>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-estrangeiro/componentes/SolicitacaoReembolsoEstrangeiroRelatorio.vue